import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebService } from '../services/web/web.service';

@Injectable({ providedIn: 'root' })
export class AllowedOriginsService {
  constructor(private webService: WebService) {}

  private baseUrl(partnerId: number): string {
    return `${this.webService.HOST}/api/partners/${partnerId}/allowed-origins`;
  }

  list(partnerId: number): Observable<any> {
    return this.webService.get(this.baseUrl(partnerId));
  }

  create(partnerId: number, origin: string): Observable<any> {
    return this.webService.post({ origin }, this.baseUrl(partnerId));
  }

  update(partnerId: number, originId: number, origin: string): Observable<any> {
    return this.webService.patch({ origin }, `${this.baseUrl(partnerId)}/${originId}`);
  }

  remove(partnerId: number, originId: number): Observable<any> {
    return this.webService.delete({}, `${this.baseUrl(partnerId)}/${originId}`);
  }

  switchToAll(partnerId: number): Observable<any> {
    return this.webService.post({}, `${this.baseUrl(partnerId)}/switch-to-all`);
  }

  switchToRestricted(partnerId: number): Observable<any> {
    return this.webService.post({}, `${this.baseUrl(partnerId)}/switch-to-restricted`);
  }
}
